module.exports = __webpack_public_path__ + "img/store-hybris.442e47f5.svg";